import { useState } from 'react';
import createDebug from 'debug';

const debug = createDebug('evp:useDraft');

type UpdateDraft<T> = (diff: Partial<T>) => void;
type ResetDraft<T> = (newDraft: T) => void;

export default function useDraft<Draft>(
  initial: Draft,
): [Draft, UpdateDraft<Draft>, ResetDraft<Draft>] {
  const [draft, setDraft] = useState(initial);

  function update(diff: Partial<Draft>): void {
    debug('Updating draft %o...', diff);
    if (diff === undefined) {
      setDraft(diff);
      return;
    }
    setDraft(prev => ({ ...prev, ...diff }));
  }

  function reset(newDraft: Draft): void {
    debug('Create new draft from %o', newDraft);
    setDraft(newDraft);
  }

  return [draft, update, reset];
}
